import React, { useMemo } from 'react';
import clsx from 'clsx';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { ReleaseNextStep } from 'fym-shared/src/music24/releases';
import { TypedMemo } from '../../../../common/types';
import { releaseNextStepText } from './releaseNextStepText';
/* eslint-disable css-modules/no-unused-class -- a shared stylesheet; each part uses its own slice of it */
import styles from './ReleasesList.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface ReleaseNextStepLineProps {
  step: ReleaseNextStep;
}

const TONE_CLASS = {
  warn: styles.markWarn,
  hot: styles.markHot,
  ok: styles.markOk,
  plain: undefined,
} as const;

/** The one next step of a release row (design a1 `.nx`): a mark, a bold line and a detail line. */
const ReleaseNextStepLineComponent: React.FC<ReleaseNextStepLineProps> = ({ step }) => {
  const intl = useIntl();
  const text = useMemo(() => releaseNextStepText(intl, step), [intl, step]);

  return (
    <div className={styles.next} data-testid="release-next-step">
      <span className={clsx(styles.nextMark, TONE_CLASS[text.tone])} aria-hidden="true">
        <FontAwesomeIcon icon={text.icon} />
      </span>
      <div className={styles.grow}>
        <b className={styles.nextTitle}>{text.title}</b>
        {text.detail !== '' && <small className={styles.nextDetail}>{text.detail}</small>}
      </div>
    </div>
  );
};

export const ReleaseNextStepLine = TypedMemo(ReleaseNextStepLineComponent);
